var exports = {
  "kL": "AddFriendSheet.module__container___RGUtaz",
  "XG": "AddFriendSheet.module__scroller___RGUtaz",
  "Qs": "AddFriendSheet.module__content___RGUtaz",
  "Y4": "AddFriendSheet.module__requestsSection___RGUtaz",
  "Ic": "AddFriendSheet.module__requestsGroup___RGUtaz",
  "sg": "AddFriendSheet.module__requestsHeader___RGUtaz",
  "vA": "AddFriendSheet.module__requestsList___RGUtaz",
  "Jt": "AddFriendSheet.module__requestDivider___RGUtaz",
};

module.exports = exports;
